export default "__VITE_ASSET__CHdSCpEe__"